import React, { useState, useCallback } from "react";
import Drawer from "@material-ui/core/Drawer";
import { Swiper, SwiperSlide } from "swiper/react";
import firstInfo1 from "bodycodi/cmap/app/img/first-in-info1.png";
import firstInfo2 from "bodycodi/cmap/app/img/first-in-info2.png";
import firstInfo3 from "bodycodi/cmap/app/img/first-in-info3.png";
import firstInfo4 from "bodycodi/cmap/app/img/first-in-info4.png";
import firstInfo5 from "bodycodi/cmap/app/img/first-in-info5.png";

interface FirstInInfo {
  setIsLoading: (isLoding: boolean) => void;
}

const TextArray = [
  {
    text1: "내 스케줄을",
    text2: "한번에 체크!",
    text3: "한 눈에 보이는 일정 관리",
    text4: "구글캘리더 연동까지!",
    image: firstInfo1,
  },
  {
    text1: "쉽고 간편하게",
    text2: "출결관리",
    text3: "출석부는 이제 그만!",
    text4: "일괄 출결석기능으로 한번에 간편하게!",
    image: firstInfo2,
  },
  {
    text1: "회원님 집중케어",
    text2: "핵심기능만 모아",
    text3: "회원 관리와 친밀한 관계형성을 위해",
    text4: "꼭 필요한 핵심 기능만 모아모아!",
    image: firstInfo3,
  },
  {
    text1: "스마트한 에디터로",
    text2: "체형분석을 쉽게",
    text3: "바디스크린에 체형 분석결과 바로 체크해서",
    text4: "회원님께 공유하면 끝!",
    image: firstInfo4,
  },
  {
    text1: "커뮤니티를 통해",
    text2: "회원님과 맞춤소통",
    text3: "이미지,영상 공유를 통한",
    text4: "실시간 소통으로 회원만족도 up!",
    image: firstInfo5,
  },
];

const DotComponent = ({ step }: { step: number }) => {
  return (
    <div className="dot-wrapper">
      {[0, 1, 2, 3, 4].map((v) => {
        if (step === v) {
          return <div key={v} className="dot active"></div>;
        } else {
          return <div key={v} className="dot"></div>;
        }
      })}
    </div>
  );
};

const FirstInInfoWrap = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const handleClose = useCallback(() => {
    setIsLoading(false);
  }, []);

  return (
    <>
      <Drawer anchor="bottom" open={isLoading} onClose={handleClose} className="picker-pop full">
        {isLoading && <FirstInInfo setIsLoading={setIsLoading} />}
      </Drawer>
    </>
  );
};

const FirstInInfo = ({ setIsLoading }: FirstInInfo) => {
  const [step, setStep] = useState(0);
  const [swiper, setSwiper] = useState<any>({});

  const handleSlide = (e: any) => {
    setStep(e.activeIndex);
  };
  const handleClickDone = () => {
    setIsLoading(false);
    window.localStorage.setItem("onBoarding", "Y");
  };

  return (
    <div className="first-info-wrapper">
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        onSlideChange={handleSlide}
        onSwiper={(swiper) => {
          setSwiper(swiper);
        }}
      >
        {TextArray.map((v) => (
          <SwiperSlide key={v.text1}>
            <div className="info-box">
              <div className="top-box">
                <img src={v.image} alt="" />
              </div>
              <div className="bottom-box">
                <div className="bottom-text-top">
                  <div className="title">{v.text1}</div>
                  <div className="title blue">{v.text2}</div>
                  <div className="desc">
                    {v.text3}
                    <br />
                    {v.text4}
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="footer">
        <DotComponent step={step} />
        <div className="footer-bottom">
          <div onClick={handleClickDone}>
            <div className="close">건너뛰기</div>
          </div>
          <div
            onClick={
              step === 4
                ? handleClickDone
                : () => {
                    swiper?.slideNext();
                  }
            }
          >
            <div className="next">{step === 4 ? "시작하기" : "다음"}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstInInfoWrap;
